import React from 'react'
import { ToastContainer } from "react-bootstrap";
import Toast from "react-bootstrap/Toast";

function ToastMessage({ message, delay, show, handleToast, type }) {
  return (
    <div>
      <ToastContainer
					className="p-3"
					position={"top-end"}
					onClick={handleToast}
					style={{ maxWidth: "20rem" }}
				>
					<Toast
						autohide
						bg={type}
						className="p-2"
						show={show}
						onClose={handleToast}
            delay={delay}
					>
						<Toast.Body style={{ fontSize: '1.5rem'}}>{message}</Toast.Body>
					</Toast>
				</ToastContainer>
    </div>
  )
}

export default ToastMessage